import { useRouter } from "next/router";

export const useGetCanonicalUrl = () => {
  const router = useRouter();
  if (!router) {
    return process.env.NEXT_PUBLIC_ZEUS_URL + "/view-tutors/";
  }
  let urlPath: string = router.asPath;
  if (urlPath.includes("#")) {
    const sanitisedUrlPath: string = urlPath.split("#")[0];
    urlPath = sanitisedUrlPath;
  }
  if (urlPath.includes("?")) {
    const sanitisedUrlPath: string = urlPath.split("?")[0];
    urlPath = sanitisedUrlPath;
  }
  const canonicalURL: string =
    process.env.NEXT_PUBLIC_ZEUS_URL + router.basePath + urlPath;
  return canonicalURL;
};
